module.exports = __webpack_public_path__ + "static/media/bg_default.d281b788.jpg";